<section class="page-hero neighborhood-page-hero compact-hero" appHeroScrollCue>
    <div class="site-container">
        <p class="eyebrow">Website policy</p>
        <h1>Privacy Policy</h1>
        <p>Last updated: May 14, 2026</p>
    </div>
</section>

<section class="section-panel">
    <div class="site-container policy-content">
        <p>
            GTX Inspections, LLC respects your privacy. This policy explains how information submitted
            through this website may be collected, used, and shared.
        </p>

        <h2>Information We Collect</h2>
        <p>
            When you submit the contact form, call, text, or email GTX Inspections, LLC, we may collect
            your name, email address, phone number, message details, and any inspection-related
            information you choose to provide. The website or hosting services may also collect basic
            technical information such as browser type, device information, IP address, pages visited,
            and timestamps for security, troubleshooting, and site performance.
        </p>

        <h2>How We Use Information</h2>
        <p>
            We use information to respond to your request, schedule or discuss inspection services,
            provide customer service, maintain business records, improve the website, and protect the
            website and business from spam, abuse, or unauthorized activity.
        </p>

        <h2>How We Share Information</h2>
        <p>
            GTX Inspections, LLC does not sell personal information. We may share information with
            service providers that help operate the website, process contact form submissions, deliver
            email, maintain records, or provide requested services. We may also disclose information
            when required by law, regulation, legal process, or to protect the rights, property, or
            safety of GTX Inspections, LLC, our clients, or others.
        </p>

        <h2>Text, Phone, and Email Communications</h2>
        <p>
            If you provide a phone number or email address, GTX Inspections, LLC may contact you about
            your inquiry, requested services, scheduling, or follow-up questions. Message and data rates
            may apply for text messages.
        </p>

        <h2>Data Retention and Security</h2>
        <p>
            We keep information only as long as reasonably necessary for business, recordkeeping,
            customer service, legal, and security purposes. We use reasonable safeguards to protect
            information, but no website, email system, or electronic storage method can be guaranteed
            to be completely secure.
        </p>

        <h2>Children's Privacy</h2>
        <p>
            This website is intended for adults seeking home inspection services. We do not knowingly
            collect personal information from children under 13.
        </p>

        <h2>Your Choices</h2>
        <p>
            You may contact us to request access to, correction of, or deletion of personal information
            you have provided, subject to legal and business recordkeeping requirements.
        </p>

        <h2>Texas Real Estate Commission Notice</h2>
        <p>
            GTX Inspections, LLC provides the
            <a href="https://www.trec.texas.gov/forms/consumer-protection-notice" target="_blank"
                rel="noopener noreferrer">TREC Consumer Protection Notice</a>
            for visitors and clients.
        </p>

        <h2>Contact Us</h2>
        <p>
            GTX Inspections, LLC<br />
            Georgetown, Texas<br />
            Phone: <a href="tel:512-848-1316">(512) 848-1316</a><br />
            Email: <a href="mailto:moreno@gtxinspections.com">moreno&#64;gtxinspections.com</a>
        </p>
    </div>
</section>
